import React from 'react';
// import { FaPlusCircle } from "react-icons/fa";
import {
    Row,
    Col,
    Statistic,
    Table,
} from 'antd';
import dayjs from 'dayjs';

const columns = [
    {
        title: 'No.',
        dataIndex: 'no',
        key: 'no',
        width: '20px'
    },
    {
        title: 'Details',
        dataIndex: 'product',
        key: 'product',
        render: (text, option) => (
            <div>
                <span style={{ display: 'block', fontWeight: 'bold', fontSize: '12px' }}>
                    {`${text.name ?? ""}`}
                </span>
                {text.category?.name === 'course' && <span style={{ fontSize: '12px' }}>
                    {`เริ่มเรียน ${dayjs(option.start_date).format('DD-MM-YYYY')} ถึง ${dayjs(option.end_date).format('DD-MM-YYYY')}`}
                </span>}
            </div>
        )
        //     //   filters: categories.map(f => ({ text: f.name, value: f.name })),
        //     //   onFilter: (value, record) => record?.category?.name.indexOf(value) === 0,
        //     //   sorter: (a, b) => a?.category?.name.localeCompare(b?.category?.name),
    },
    {
        title: 'Price',
        dataIndex: 'price',
        key: 'price',
        render: (text, _) => <Statistic value={text} precision={2} valueStyle={{ fontSize: 14, textAlign: 'right' }} />,
    },
    {
        title: 'Quantity',
        dataIndex: 'quantity',
        key: 'quantity',
        render: (text, _) => <Statistic value={text} valueStyle={{ fontSize: 14, textAlign: 'right' }} />,
    },
]

function OrderItemsDetail({ orderItems }) {

    // console.log('orderItems =', orderItems);
    return (
        <Row justify='end' gutter={[16, 16]}>
            <Col xs={24}>
                <Table
                    rowKey={(record) => record._id}
                    columns={columns}
                    dataSource={orderItems.map((item, idx) => ({ ...item, no: idx + 1 }))}
                    pagination={false}
                    scroll={{
                        x: 800,
                    }}
                />
            </Col>
        </Row>
    )
}

export default OrderItemsDetail